import React, {useState} from "react";
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import {UserBasic} from "../../../service/types/types";
import {useNavigate} from "react-router-dom";
import {UserBasicService} from "../../../service/users-basic.service";

interface Props {
    user: UserBasic;
    refreshUser: () => Promise<void>;
}

export default function UpdateUserBasic({user, refreshUser}: Props) {
    const [formData, setFormData] = useState<UserBasic>({
        rut: user.rut,
        nombre: user.nombre,
        cargo: user.cargo,
        correo: user.correo,
        zona: user.zona,
    });
    const navigate = useNavigate();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const {name, value} = e.target;
        setFormData(prev => ({...prev, [name]: value}));
    };

    const handleSubmit = async (e?: React.FormEvent) => {
        e?.preventDefault();
        try {
            await UserBasicService.update(formData.rut, formData);
            alert("Usuario actualizado exitosamente");
            refreshUser();
        } catch (error) {
            console.error("Error updating user:", error);
            alert("Error actualizando usuario: " + (error as any)?.message || "Error desconocido");
            return;
        }
    };

    return (
        <div className="w-100 min-vh-100 bg-light p-3">
            <Container fluid className="p-4 bg-white shadow rounded">
                <h2 className="mb-4">Crear Usuario</h2>
                <Form onSubmit={handleSubmit} className="w-100">
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>RUT *</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="rut"
                                    value={formData.rut}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Nombre *</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="nombre"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Cargo</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="cargo"
                                    value={formData.cargo}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Zona</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="zona"
                                    value={formData.zona}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Correo</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="correo"
                                    value={formData.correo}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Button variant="primary" type="submit" className="w-100 mt-3">
                        Editar Usuario
                    </Button>
                </Form>
            </Container>
        </div>
    );
}